import script from "./RegistrationDone.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationDone.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationDone.vue?vue&type=style&index=0&id=3d7c348c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7c348c"]])

export default __exports__